import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, type OnInit } from '@angular/core';
import { KuiTabsModule } from 'app/key-ui';
import { KeyMediaModule } from 'app/shared/components/media/media.module';

export interface LiveCamera {
    assetId: string;
    cameraId: string;
    cameraName: string;
}

@Component({
    selector: 'key-video-request-livestream',
    standalone: true,
    imports: [
        CommonModule,
        KeyMediaModule,
        KuiTabsModule
    ],
    templateUrl: './livestream-viewer.component.html',
    styleUrl: './livestream-viewer.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoRequestLivestreamComponent implements OnInit {
    
    cameras = input.required<LiveCamera[]>();

    ngOnInit(): void { }

}
